<app-base-modal dialogTitle="Custom Period" (closeEvent)="onCancel()">
  <div class="modal-hint">Select a start and end date to view insights for this time range.</div>
  <form [formGroup]="dateForm" class="form-group">
    <div class="main-container">
      <mat-form-field appearance="outline">
        <mat-label>Start Date</mat-label>
        <input matInput [matDatepicker]="startPicker" formControlName="dateStart" placeholder="Select start date" />
        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
        @if (dateForm.get('dateStart')?.hasError('required')) {
          <mat-error> Start date is required </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>End Date</mat-label>
        <input matInput [matDatepicker]="endPicker" formControlName="dateEnd" placeholder="Select end date" />
        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
        @if (dateForm.get('dateEnd')?.hasError('required')) {
          <mat-error> End date is required </mat-error>
        }
      </mat-form-field>
    </div>
    @if (this.dateForm.hasError('dateRangeInvalid')) {
      <mat-error> Start date cannot be before end date! </mat-error>
    }
  </form>

  <!-- This is projected by the ng-content of the app-base-modal -->
  <div panel-footer>
    <button mat-flat-button class="button-link" (click)="onCancel()">Cancel</button>
    <button mat-flat-button class="button-primary" (click)="onApply()" [disabled]="!dateForm.valid">Apply</button>
  </div>
</app-base-modal>
